module.exports = __webpack_public_path__ + "static/media/map.35f6852f.svg";